<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <span>
      {{ !name ? mobileTitle : name }}
    </span>
  </div>
  <div
    v-else
    :class="$vuetify.breakpoint.mdAndDown ? 'small-breadcrumb' : 'breadcrumb'"
  >
    <v-breadcrumbs :items="items" class="pa-0">
      <template v-slot:divider>
        <v-icon size="28">mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :to="{ path: item.href }"
          class="title"
          :class="{ 'pb-0': $vuetify.breakpoint.mdAndDown }"
        >
          <strong
            :class="
              checkMenuIndex(item)
                ? 'sub-item-title'
                : items.length > 1
                ? 'breadcrumb-item-title'
                : ''
            "
          >
            {{ item.text }}</strong
          >
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    name: {
      default: null
    }
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    name() {
      this.updateItems();
    },
    $route() {
      this.items = this.$route.meta.breadCrumb;
      this.updateItems();
    }
  },
  created() {
    this.items = this.$route.meta.breadCrumb;
  },
  mounted() {
    this.updateItems();
  },
  methods: {
    updateItems() {
      if (this.$route.params.id) {
        let name = this.$route.name;
        if (this.name !== "") {
          name = this.name;
        }
        if (this.$route.meta.breadCrumb[0].text === "Home") {
          this.$set(this.items, 2, {
            text: name
          });
        } else {
          this.$set(this.items, 1, {
            text: name
          });
        }
      }
    },
    checkMenuIndex(firstElement) {
      let isSecondElement = false;
      if (this.items && this.items.length > 1) {
        const index = this.items.findIndex(
          element => element.text === firstElement.text
        );
        if (index) isSecondElement = true;
      }
      return isSecondElement;
    }
  }
};
</script>
<style>
.breadcrumb li {
  padding: 0px;
}
.breadcrumb .title a {
  color: rgba(0, 0, 0, 0.87) !important;
  font-family: "Now Alt" !important;
}
.breadcrumb li strong {
  max-width: 400px;
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb-item-title {
  color: #1040cf !important;
  width: max-content !important;
}
.sub-item-title {
  color: #677c95 !important;
}
.v-application .title strong {
  font-size: 16px !important;
  font-weight: 500;
  font-family: "Now Alt" !important;
}
.small-breadcrumb li strong {
  max-width: 210px;
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .breadcrumb .v-breadcrumbs__divider {
  padding: 0px 5px !important;
} */
.subtitle-text-style {
  width: calc(30vw) !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 1 !important;
  -webkit-box-orient: vertical !important;
}
</style>
